//This must be a global to allow the recaptcha script to access it
function recaptchaModalResponse(token) {
    $("#recaptchaModalToken").val(token);
}

(function () {
    $(document).ready(function () {
        if (DoesNewsletterCookieExist() === false) {
            if (AlreadySignedUp() === true) {
                CreateDoNotShowCookie();
            }
            else {
                //Setup newsletter modal
                $("#newsletterSignupModal").on("hide.bs.modal", function () {
                    $(".modal-backdrop").removeClass("fadeIn").addClass("fadeOut");
                });

                $("#newsletterSignupModal_Form").submit(function (event) {
                    event.preventDefault();
                  
                    if (validate() === false) {
                        return;
                    }
                  
                    SubmitNewsletterSignup();
                });

                if (AlreadyShownNewsletterPopup() === true) {
                    //If the modal has already been displayed, show the small image
                    setupDiscount();
                }
                else {
                    //Display the modal
                    setTimeout(
                        function () {
                            $("#newsletterSignupModal").modal("show");
                            $(".modal-backdrop").addClass("fadeIn").removeClass("fadeOut");
                        }, 2500
                    );
                }
            }
        }
    });

    function AlreadyShownNewsletterPopup() {
        if (document.cookie.indexOf("mm_newsletter_shownpopup") === -1) {
            //Create cookie to show small image instead of popup
            var d = new Date();
            d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
            var expires = "expires=" + d.toUTCString();
            document.cookie = "mm_newsletter_shownpopup=1;" + expires + ";path=/";

            return false;
        }
        else {
            //Display small image
            return true;
        }
    }

    function AlreadySignedUp() {
        if (document.getElementById("alreadySignedUpForNewsletter")) {
            return true;
        }
        else {
            return false;
        }
    }

    function CreateDoNotShowCookie() {
        //Create a cookie to make sure the popup isn't displayed again
        var d = new Date();
        d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = "mm_newsletter_offer=0;" + expires + ";path=/";
    }

    function DoesNewsletterCookieExist() {
        if (document.cookie.indexOf("mm_newsletter_offer") === -1) {
            return false;
        }
        else {
            CreateDoNotShowCookie();
            return true;
        }
    }

    function setupDiscount() {
        let discount = document.getElementById("newsletterSignupDiscount");
        discount.classList.add("fadeIn");

        discount.addEventListener("click", (event) => {
            event.preventDefault();
            $("#newsletterSignupModal").modal("show");
            $(".modal-backdrop").addClass("fadeIn").removeClass("fadeOut");
        });

        document.querySelector("#newsletterSignupDiscount .close-newsletter-signup-discount").addEventListener("click", (event) => {
            event.stopPropagation();
            discount.classList.remove("fadeIn");
            discount.classList.add("fadeOut");
        });
    }

    function SubmitNewsletterSignup() {
        Utility.showLoadingModal();

        $.ajax({
            type: 'POST',
            url: 'https://api.meyernaturalfoods.com/api/v1/newsletter/submit',
            datatype: "json",
            data: JSON.stringify({
                email: $("#newsletterSignupModal_Email").val(),
                firstName: $("#newsletterSignupModal_FirstName").val(),
                lastName: $("#newsletterSignupModal_LastName").val(),
                postalCode: $("#newsletterSignupModal_ZipCode").val(),
                recaptchaToken: $("#recaptchaModalToken").val()
            }),
            contentType: "application/json; charset=utf-8"
        }).done(function (data) {
          if (typeof data.success !== "undefined" && data.success === true) {
            $("#newsletterSignupModal_Message").text("Thank you for signing up for the Meyer Market newsletter.  You should receive an email with information on how to confirm your email.")
              .removeClass("hidden")
              .addClass("success");
            $(".instructions").addClass("hidden");
              $("#newsletterSignupModal_Form").addClass("hidden");
              $("#newsletterSignupModal #newsletterSignupModal_Container .offer").addClass("hidden");
          }
          else {
            Utility.displayMessage("error", "#newsletterSignupModal_Message", Object.entries(data.errors).map((item) => item[1]).join("<br>"));
          }
        }).fail(function (data) {
          if (typeof data.responseJSON.errors !== "undefined"){
            Utility.displayMessage("error", "#newsletterSignupModal_Message", Object.entries(data.responseJSON.errors).map((item) => item[1]).join("<br>"));
          }
          else{
            Utility.displayMessage("error", "#newsletterSignupModal_Message", "Sorry for the inconvenience, but an error has occurred.  Please reload the page and try again.");  
          }
        }).always(function () {
            Utility.hideLoadingModal();
        });
    }

    function validate() {
        if ($("#newsletterSignupModal_FirstName").val().trim().length === 0) {
            $("#newsletterSignupModal_Message").text("Please enter your First Name.");
            $("#newsletterSignupModal_Message").removeClass("hidden");
            return false;
        }

        if ($("#newsletterSignupModal_LastName").val().trim().length === 0) {
            $("#newsletterSignupModal_Message").text("Please enter your Last Name.");
            $("#newsletterSignupModal_Message").removeClass("hidden");
            return false;
        }

        if ($("#newsletterSignupModal_ZipCode").val().trim().length === 0) {
            $("#newsletterSignupModal_Message").text("Please enter your Zip Code.");
            $("#newsletterSignupModal_Message").removeClass("hidden");
            return false;
        }

        if ($("#newsletterSignupModal_Email").val().trim().length === 0) {
            $("#newsletterSignupModal_Message").text("Please enter your Email.");
            $("#newsletterSignupModal_Message").removeClass("hidden");
            return false;
        }

        if ($("#recaptchaModalToken").val().length == 0) {
            $("#newsletterSignupModal_Message").text("Please check the box \"I'm not a robot.\"");
            $("#newsletterSignupModal_Message").removeClass("hidden");
            return false;
        }

        $("#newsletterSignupModal_Message").text("");
        $("#newsletterSignupModal_Message").addClass("hidden");
        return true;
    }
})();